export const menuCategories = {
  SETTINGS: 'Settings',
  FINANCIAL_INFO: 'FinancialInfo',
  DOCUMENTS: 'Documents',
  DICTIONARIES: 'Dictionaries',
  FINANCIAL_PRODUCT: 'FinancialProduct',
  SCORING: 'Scoring',
  APPROVALS: 'Approvals',
  REPORTS: 'Reports',
  FORMULAS: 'Formulas',
  QUESTIONNAIRES: 'Questionnaires',
  INFRASTRUCTURE_SERVICES: 'InfrastructureServices',
  VERIFICATION_TYPES: 'VerificationTypes',
  USERS: 'Users',
  SERVICES: 'Services',
  INSURANCE: 'Insurance',
  RESIDUAL_VALUE_GRID: 'ResidualValueGrid',
  LEASING_INCOME_SCHEMA: 'LeasingIncomeSchema',
  SCHEDULES: 'Schedules',
  DMS: 'DMS',
  NON_WORKING_DAYS: 'NonWorkingDays'
};
